import React from "react";
import { History } from "lucide-react";

const SessionHistorySection = () => {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4 max-w-3xl text-center">
        <div className="inline-flex p-3 rounded-xl bg-primary/10 mb-6">
          <History className="w-8 h-8 text-primary" />
        </div>
        <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6">
          Session History
        </h2>
        <p className="text-lg text-muted-foreground leading-relaxed">
          Every session is saved so you can compare impressions with the reveal later. 
          Over time, your history becomes your training log — what you noticed, what matched, 
          and what you want to explore next.
        </p>
      </div>
    </section>
  );
};

export default SessionHistorySection;
